import { createRoute, useParams } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { CourseDetailView } from "@/features/courses/components/catalog/course-detail-view";

function CatalogCoursePage() {
  const params = useParams({ from: "/u/$u/catalog/$courseId" });
  return <CourseDetailView courseId={params().courseId} />;
}

export const catalogCourseRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/catalog/$courseId",
  component: CatalogCoursePage,
});
